var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "train-list-container" }, [
    _c(
      "div",
      { staticClass: "cards-grid" },
      _vm._l(_vm.cardList, function(item, index) {
        return _c("div", { key: index, staticClass: "card-item" }, [
          _c("div", { staticClass: "card-image" }, [
            _c("img", { attrs: { src: item.majorImg, alt: item.title } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-content" }, [
            _c("div", { staticClass: "card-title" }, [
              _vm._v(_vm._s(item.majorTitle))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "card-button",
                on: {
                  click: function($event) {
                    return _vm.handleCardClick(item)
                  }
                }
              },
              [_vm._v("点击进入")]
            )
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a8a8421", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a8a8421","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/trainList.vue
// module id = 1551
// module chunks = 0